export const fontSizeConstant = [5, 6, 7, 8, 9, 10, 11, 12];
export const rowsPerPageConstant = [5, 10, 20, 50, 75, 100];
